import { render, staticRenderFns } from "./detailPic.vue?vue&type=template&id=07a1e8d2&scoped=true&"
import script from "./detailPic.vue?vue&type=script&lang=js&"
export * from "./detailPic.vue?vue&type=script&lang=js&"
import style0 from "./detailPic.vue?vue&type=style&index=0&id=07a1e8d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a1e8d2",
  null
  
)

export default component.exports